import changeCurrentLocation from 'actions/lib/change_current_location';
import ExternalCustomerLookup from 'models/location/external_customer_lookup';
import { getSuggestionCount } from './lib/lookup_result';

export default class OpenExternalCustomerLookup {
  constructor(context) {
    this.context = context;
  }

  run(customerId) {
    let externalCustomerLookup = ExternalCustomerLookup.create({
      customerId,
    });
    changeCurrentLocation(this.context, externalCustomerLookup);

    this.context.analytics.track('Customer Profile Lookup - Opened', {
      customerId,
      itemCount: getSuggestionCount(this.context),
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/open_external_customer_lookup.js